import { render, staticRenderFns } from "./UploadProfilePic.vue?vue&type=template&id=ba3a7094&"
import script from "./UploadProfilePic.vue?vue&type=script&lang=js&"
export * from "./UploadProfilePic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports